const headerData = [{
		prop: "InvoiceCheckedName",
		label: "发票校验状态",
		columnwidth: 200
	}, {
		prop: "InvoiceNo",
		label: "发票号码",
		columnwidth: 200
	}, {
		prop: "SBDate",
		label: "发票日期",
		columnwidth: 200
	}, {
		prop: "SBMonth",
		label: "发票年月",
		columnwidth: 200
	}, {
		prop: "ReturnFlagName",
		label: "发票方向",
		columnwidth: 200
	}, {
		prop: "DPDate",
		label: "出库日期",
		columnwidth: 200
	}, {
		prop: "DPMonth",
		label: "出库年月",
		columnwidth: 200
	}, {
		prop: "CreateOrgName",
		label: "开票方",
		columnwidth: 200
	}, {
		prop: "CusName",
		label: "付款方",
		columnwidth: 200
	}, {
		prop: "HosType",
		label: "付款方类型",
		columnwidth: 200
	}, {
		prop: "TerminalHPName",
		label: "终端医院",
		columnwidth: 200
	}, {
		prop: "TechnicalOffices",
		label: "院区/科室",
		columnwidth: 200
	}, {
		prop: "TerminalHPCode",
		label: "医院编码",
		columnwidth: 200
	}, {
		prop: "HosGradeName",
		label: "医院等级",
		columnwidth: 200
	}, {
		prop: "ProvinceName",
		label: "省份",
		columnwidth: 200
	}, {
		prop: "CityName",
		label: "城市",
		columnwidth: 200
	}, {
		prop: "DistrictName",
		label: "区县",
		columnwidth: 200
	}, {
		prop: "SalesMan",
		label: "销售人员",
		columnwidth: 200
	},
	{
		prop: "ProvinceMan",
		label: "省级经理",
		columnwidth: 200
	},
	{
		prop: "AreaMan",
		label: "地区经理",
		columnwidth: 200
	}, {
		prop: "RegionMan",
		label: "大区经理",
		columnwidth: 200
	}, {
		prop: "CountryMan",
		label: "全国总监",
		columnwidth: 200
	}, {
		prop: "CreateTime",
		label: "上传日期",
		columnwidth: 200
	}, {
		prop: "InvAddCode",
		label: "产品代码",
		columnwidth: 200
	}, {
		prop: "InvName",
		label: "产品名称",
		columnwidth: 200
	}, {
		prop: "Batch",
		label: "批号",
		columnwidth: 200
	}, {
		prop: "ValiDate",
		label: "失效日期",
		columnwidth: 200
	}, {
		prop: "UnitName",
		label: "单位",
		columnwidth: 200
	}, {
		prop: "Quantity",
		label: "数量",
		columnwidth: 200
	}, {
		prop: "FUnitName",
		label: "辅助计量单位",
		columnwidth: 200
	}, {
		prop: "FQuantity",
		label: "辅助单位数量",
		columnwidth: 200
	}, {
		prop: "TaxUnitPrice",
		label: "含税单价",
		columnwidth: 200
	}, {
		prop: "Sum",
		label: "价税合计",
		columnwidth: 200
	}, {
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 200
	}, {
		prop: "MFName",
		label: "生产厂商",
		columnwidth: 200
	}, {
		prop: "LEVEL1",
		label: "Level 1",
		columnwidth: 200
	}, {
		prop: "LEVEL2",
		label: "Level 2",
		columnwidth: 200
	}, {
		prop: "LEVEL3",
		label: "Level 3",
		columnwidth: 200
	}, {
		prop: "LEVEL4",
		label: "Level 4",
		columnwidth: 200
	}, {
		prop: "StandardCost",
		label: "参考价格",
		columnwidth: 200
	}, {
		prop: "StandardSum",
		label: "参考价格合计",
		columnwidth: 200
	}, {
		prop: "ErrMessage",
		label: "报错信息",
		columnwidth: 200
	}, {
		prop: "InvoiceErrType",
		label: "报错分类",
		columnwidth: 200
	}, {
		prop: "CheckedRemark",
		label: "发票标注内容",
		columnwidth: 200
	}, {
		prop: "VerifyTime",
		label: "审核日期",
		columnwidth: 200
	}
]

export default headerData;